import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface iAppbarState {
  anchorEl: null | HTMLElement;
  notifications: { content: string; category: string }[];
}

const appbarState: iAppbarState = {
  anchorEl: null,
  notifications: [{ content: "testing", category: "chemgen1" }],
};

export const appbarSlice = createSlice({
  name: "appbar",
  initialState: appbarState,
  reducers: {
    openAvatarMenu: (
      state: any,
      action: PayloadAction<{ anchorEl: HTMLElement }>
    ) => {
      state.anchorEl = action.payload.anchorEl;
    },
    closeAvatarMenu: (state: any) => {
      state.anchorEl = null;
    },
  },
});

// Action creators are generated for each case reducer function
export const { openAvatarMenu, closeAvatarMenu } = appbarSlice.actions;

export default appbarSlice.reducer;
